<template>
  <!--自助门禁  扫描-->
  <div v-if="errorCode === 0">
    <div class="mj_one">
      <p>{{ config.accessControlName }}</p>
      <p>门禁模式：{{ getAccessControlMode(config.accessControlMode) }}</p>
      <p v-if="config.accessControlMode === 2">
        验证模式：{{
          `${getLimitMode(config.limitMode)} ${config.limitCount}次`
        }}
      </p>
    </div>
    <dl class="mj_two">
      <dt>本机位置：{{ config.accessControlName }}</dt>
      <dt>操作用户：{{ config.phone }}</dt>
    </dl>
    <div class="mj_three">
      <button class="btn_saoMiao" @click="startScan">开始扫描</button>
    </div>

    <ul class="mj_four">
      <template v-if="config.accessControlMode !== 1">
        <li>
          <!-- <img src="@/assets/img/mj1.png" alt="" />
          <img src="@/assets/img/mj2.png" alt="" />
          <img src="@/assets/img/mj3.png" alt="" />
          <img src="@/assets/img/mj4.png" alt="" /> -->
        </li>
        <li>
          <span class="s1">{{ resultData.surplusCount }}</span
          >/<span class="s2">{{ config.limitCount }}</span>
        </li>
        <li>
          <!-- <img src="@/assets/img/mj5.png" alt="" />
          <img src="@/assets/img/mj6.png" alt="" />
          <img src="@/assets/img/mj7.png" alt="" />
          <img src="@/assets/img/mj8.png" alt="" /> -->
        </li>
      </template>
    </ul>
    <dl class="mj_five">
      <dt>入场时间：{{ resultData.entryTime }}</dt>
      <dt>入场位置：{{ resultData.entryLocation }}</dt>
    </dl>
    <ul class="mj_six">
      <li>
        <img src="@/assets/img/mj9.png" alt="" />
        <h2 class="num">{{ stats.totalVisitors }}</h2>
        <p>总人次</p>
      </li>
      <li>
        <img src="@/assets/img/mj10.png" alt="" />
        <h2 class="num">{{ stats.totalPeople }}</h2>
        <p>总人数</p>
      </li>
      <li class="li">
        <img src="@/assets/img/mj11.png" alt="" />
        <h2 class="num">{{ stats.todayVisitors }}</h2>
        <p>今日人次</p>
      </li>
      <li class="li">
        <img src="@/assets/img/mj12.png" alt="" />
        <h2 class="num">{{ stats.todayPeople }}</h2>
        <p>今日人数</p>
      </li>
    </ul>

    <div class="mj_seven">详细数据可往现场管理系统中进行查询</div>
  </div>
  <div v-else>
    <div class="m_Main">
      <div class="m_one">
        <img src="@/assets/img/ts1.png" class="img" />
        <div class="tit">{{ formData.code }}</div>
        <div class="desc">
          对不起<br />
          {{ errorMessage }}<br />
          <span v-if="errorCode === -4">（{{ config.limitCount }}次）</span>
        </div>
      </div>
      <div class="m_btn">
        <button class="btn" v-if="config.accessControlMode === 4">
          欢迎入场
        </button>
        <button class="btn btnRed" @click="errorCode = 0">拒绝入场</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  name: "",
  data() {
    return {
      scanText: "",
      errorCode: 0,
      errorMessage: "",
      stats: {
        totalVisitors: 0,
        totalPeople: 0,
        todayVisitors: 0,
        todayPeople: 0,
      },
      formData: {
        alias: this.$route.query.alias,
        pointId: this.$route.query.point,
        code: "",
      },
      // 扫描完成后返回的data
      resultData: {
        entryLocation: "",
        entryTime: "",
        surplusCount: 0,
      },
    };
  },
  mounted() {
    if (this.scannedCode) {
      this.onDecode(this.scannedCode);
      this.clearScannedCode();
    }
    const pointId = this.$route.query.point;
    !!pointId && this.getStatistic(pointId);
  },
  computed: {
    ...mapState("scanStore", ["scannedCode"]),
    ...mapGetters({
      config: "accessControlStore/getConfig",
    }),
  },
  methods: {
    ...mapMutations("scanStore", ["clearScannedCode"]),
    getAccessControlMode(mode) {
      switch (mode) {
        case 1:
          return "统计门禁";
        case 2:
          return "验证门禁";
        case 3:
          return "人像门禁";
        case 4:
          return "进出门禁";
      }
    },
    getLimitMode(mode) {
      switch (mode) {
        case 0:
          return "不限";
        case 1:
          return "单日";
        case 2:
          return "展期";
        case 3:
          return "任一日";
      }
    },
    async getStatistic(pointId) {
      const res = await this.$get(
        `/api/AccessControl/GetStatisticByPointId/${pointId}`
      );
      if (res.code === 200) {
        this.stats = { ...res.data };
      }
    },
    // 扫码结果回调
    onDecode(text) {
      this.formData.code = text;
      this.remoteSearch();
    },
    startScan() {
      this.$router.push({ path: "/scan" });
    },
    async remoteSearch() {
      const pointId = this.$route.query.point;
      let res;
      try {
        res = await this.$post("/api/AccessControl/StartScan", this.formData);
        if (res.code === 200) {
          this.resultData = { ...res.data };
          this.getStatistic(pointId);
        } else {
          if ([-1, -2, -3, -4].includes(res.code)) {
            this.errorCode = res.code;
            this.errorMessage = res.message;
          }
        }
      } catch {
        res = null;
      }
    },
    bindNext() {
      this.$router.push("/accessControl/information");
    },
  },
};
</script>

<style></style>
